import { DefaultResponse } from "../../types/default-response.dto";
import { createAuthClient } from "../auth/auth.client";
import {
  CHANGE_DISTRIBUTOR_ACCOUNT_PLAN,
  FETCH_ACCOUNT_PLAN_ACTIONS,
  FETCH_ACCOUNT_PLANS,
  FETCH_BILLS,
} from "./billing.queries";

export const fetchAccountPlans = async (): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_ACCOUNT_PLANS, {});
};

export const changeDistributorAccountPlan = async (
  accountPlanId: string
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(CHANGE_DISTRIBUTOR_ACCOUNT_PLAN, { accountPlanId });
};

export const fetchAccountPlanActions = async (
  accountPlanId: string
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_ACCOUNT_PLAN_ACTIONS, { accountPlanId });
};

export const fetchBills = async (): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_BILLS);
};
